function createDictionary(list: any[], key = 'id', value = 'name'): Record<string, string> {
  return list.reduce((acc, v) => {
    acc[v[key]] = v[value];
    return acc;
  }, {});
}

export default createDictionary;
